import { defaultIcon } from "./markerIcons";

export function restoreMarkerIcons(markers: google.maps.Marker[]) {
    markers.forEach((m) => m.setIcon(defaultIcon));
}
